<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app">
            <v-app id="inspire">
                <v-card v-model="show" color="#FFFF99">
                    <v-card-title>
                        <v-toolbar>
                            <v-toolbar-title class="my-0 py-0">Listado de Objetivos</v-toolbar-title>
                            <v-spacer></v-spacer>
                            Fecha de Captura: {{ fecha }}
                            <v-spacer></v-spacer>
                            EI 100
                            <v-spacer></v-spacer>
                            <div>
                                <v-btn icon @click="show = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                        </v-toolbar>
                    </v-card-title>

                </v-card>
                <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                    :items-per-page="4000" hide-default-footer :item-class="row_classes" :loading="loadtable"
                    loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                    <template v-slot:item.referencia="{ item }">
                        <pre style="white-space: pre-line;">{{ item.referencia }}</pre>
                    </template>
                    <!-- <template v-slot:item.valoractual="{ item }">
                    <v-icon small color="black" class="mr-2" @click.stop="editarCumplimiento(item)">
                        mdi-check-circle
                    </v-icon>
                    {{ item.valoractual }}
                </template> -->
                    <!-- <template v-slot:item.ver="{ item }">
                    <v-icon small color="blue" class="mr-2" @click.stop="editarInforme(item)">
                        mdi-pencil
                    </v-icon>
                </template> -->
                </v-data-table>
            </v-app>
        </div>
    </v-dialog>
</template>
<style scoped>
.font-class-name2 {
    font-size: 12px !important;
}

::v-deep .v-data-table .v-data-table__wrapper td {
    font-size: 12px !important;
    padding: 2px 4px !important;
}

::v-deep .v-data-table .v-data-table-header tr th {
    font-size: 12px !important;
    padding: 2px 4px !important;
}
</style>
<script>
import axios from "../../axios-auth.js";
import moment from "moment";
export default {
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        listado: [],
        loadtable: false,
        headers: [
            {
                text: "Código",
                align: "center",
                sortable: false,
                value: "codgral",
            },
            { text: "Proceso", value: "proceso", sortable: false },
            { text: "Tipo", value: "tipo", sortable: false },
            { text: "Objetivo", value: "objetivo", align: "center", sortable: false },
            { text: "Meta", value: "meta", align: "center", sortable: false },
            { text: "Responsable", value: "responsable", align: "center", sortable: false },
            { text: "Plazo", value: "plazo", align: "center", sortable: false },
            { text: "Indic.", value: "indicador", align: "center", sortable: false },
            { text: "Valor Anterior", value: "valorant", sortable: false },
            { text: "Valor Actual", value: "valoractual", align: "center", sortable: false },
            { text: "Referencia", value: "referencia", align: "center", sortable: false },
            { text: "Observaciones", value: "observ", sortable: false },
            { text: "Plan", value: "plan", align: "center", sortable: false },
            { text: "Rev.", value: "fecha", align: "center", sortable: false },
        ],
    }),
    props: ["visible", "fecha"],
    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.cargarListado();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        row_classes(item) {
            if (item.valoractual != null && item.valoractual != "") {
                if (item.valoractual == "0") {
                    return "red";
                }
                if (item.valoractual == "100") {
                    return "green";

                }
                if (item.valoractual.replace(",", ".") > 0 && item.valoractual.replace(",", ".") < 100) {
                    return "yellow";
                }
            }
        },

        cargarListado() {
            this.loadtable = true;
            const fecha = this.fecha;

            let self = this;
            axios
                .get("/Indicadores/ListadoObjetivosParciales?", {
                    params: {
                        fecha: fecha,

                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                    console.log(self.listado)
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },
    },
};
</script>